/**
 * Remembers "I wanted to RSVP to this event" across the sign-in round trip,
 * so a pilot who authenticates mid-flow lands back on the event, not on a
 * generic dashboard. Stored in localStorage with a timestamp: an Apple/Google
 * round trip or an emailed code can land in a new tab, and a stale memory must
 * never hijack a sign-in an hour later. Browser-only; safe to call from
 * effects and handlers.
 */
const KEY = "squadflight.rsvpIntent";
const MAX_AGE_MS = 30 * 60_000;

export function setRsvpIntent(slug: string): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ slug, at: Date.now() }));
  } catch {
    /* private mode — the pilot just lands on their profile instead */
  }
}

export function takeRsvpIntent(): string | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    window.localStorage.removeItem(KEY);
    // Older entries were the bare slug; treat them as fresh rather than lose one.
    if (!raw.startsWith("{")) return raw || null;
    const parsed = JSON.parse(raw) as { slug?: unknown; at?: unknown };
    const slug = typeof parsed.slug === "string" ? parsed.slug : null;
    const at = typeof parsed.at === "number" ? parsed.at : 0;
    if (!slug || Date.now() - at > MAX_AGE_MS) return null;
    return slug;
  } catch {
    return null;
  }
}
